import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapButton = React.lazy(function () {
    return import('../../bootstrap-components/components/BTButton');
});
var onClick = function (props) {
    props.onClick();
};
var bootStrapButton = function (props) {
    var newProps = __assign(__assign({}, props), { onClick: function () { return onClick(props); } });
    return (React.createElement(BootStrapButton, __assign({}, newProps)));
};
var Button = function (props) {
    var componentToDisplay = bootStrapButton(props);
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapButton(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) },
            " ",
            componentToDisplay,
            " ")));
};
Button.defaultProps = {
    styleName: 'primary',
    name: 'ButtonTest',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(Button);
//# sourceMappingURL=Button.js.map